import { Box, BoxProps, styled } from "@mui/material";

export const BoxGlossary = styled((props: BoxProps) => <Box {...props} />)(({ theme }) => ({
    overflowX: "hidden",
    overflowY: "scroll",
    marginLeft: "150px",
    paddingRight: "100px",
    width: "100vw",
    "@media (min-width: 300px) and (max-width: 600px)": {
        padding: "16px",
        margin: "16px",
        "#subtitle-glossary": {
            fontSize: "14px",
        },
    },
}));
